export default __webpack_public_path__ + "static/media/nftMarketBanner.54040075.png";